export const MotionPhase = Object.freeze({
    Initial: 'initial',
    Enter: 'enter',
    Exit: 'exit'
});

export type MotionPhaseType = (typeof MotionPhase)[keyof typeof MotionPhase];
